import dayjs from "dayjs"
import { useEffect } from "react"

import { useSubscriberInfo } from "../networking/queries"
import { useFamilyQuery } from "../networking/queries"
import { useUserQuery } from "../networking/queries"
import { history, useRouter } from "../util/router"
import { localStorageItems } from "../util/storage"

export const usePaywall = () => {
  const { user } = useUserQuery()
  const { data: family } = useFamilyQuery()
  const { data: subscriber } = useSubscriberInfo()
  const router = useRouter()

  useEffect(() => {
    const isFromCoachOnboarding = localStorage.getItem(
      localStorageItems.isFromCoachOnboarding
    )
    const needsToSeePaywall = localStorage.getItem(
      localStorageItems.needsToSeePaywall
    )
    const redirectLink = localStorage.getItem(localStorageItems.redirectLink)
    if (!user || !family) return

    // Skip paywall for coaching-only flow - explicit check for "true"
    if (isFromCoachOnboarding === "true") {
      localStorage.removeItem(localStorageItems.needsToSeePaywall)
      return
    }

    // eventually we want to instead have everyone sent to the paywall
    // and the paywall is dynamic with the redirect link params
    // For now, if they have redirect, they bypass paywall
    if (!!redirectLink) {
      history.push(redirectLink)
      localStorage.removeItem(localStorageItems.redirectLink)
      localStorage.removeItem(localStorageItems.needsToSeePaywall)
    } else if (!!needsToSeePaywall) {
      // If a user is not a coparent, or if they are a coparent and not subscribed, show them paywall
      const userIsCoparent = localStorage.getItem(localStorageItems.isCoparent)
      const familyIsSubscribed = subscriber?.active_plan?.is_active
      const isOnCheckoutPage = router.pathname.includes("/checkout")
      if (isOnCheckoutPage) return

      if (!userIsCoparent || !familyIsSubscribed) {
        history.push("/paywall/trial")
        localStorage.removeItem(localStorageItems.needsToSeePaywall)
        localStorage.removeItem(localStorageItems.isCoparent)
        localStorage.setItem(
          localStorageItems.lastSeenPaywall,
          dayjs().format("YYYY-MM-DD")
        )
      }
    }
  }, [user, family, subscriber]) // eslint-disable-line react-hooks/exhaustive-deps
}
